import { Alert } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { resetPassword } from '../../api/constlink';
import ResetPasswordComponent from '../../components/auth/ResetPasswordComponent';
import { RootState } from '../../modules';

function ResetPasswordContainer({ history, match }: RouteComponentProps) {
  const [message, setMessage] = useState<any>();
  const user = useSelector((state: RootState) => state.auth.auth.data);

  // const handleClose = () => {
  //   setMessage(null);
  // };

  const onFinish = async ({ currentPassword, newPassword }: any) => {
    const res = await resetPassword({
      data: { currentPassword, newPassword, email: user?.email },
    });

    if (res.isPasswordChanged)
      setMessage({ message: '비밀번호가 변경 되었습니다.', isError: false });
    else
      setMessage({
        message: '[비밀번호 변경 실패] 현재 비밀번호가 올바른지 확인해 주세요.',
        isError: true,
      });
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      {message ? (
        <Alert
          message={`${message.message}`}
          type={message.isError ? 'error' : 'success'}
          closable
          // afterClose={handleClose}
        />
      ) : null}
      <ResetPasswordComponent
        onFinish={onFinish}
        goBack={goBack}
        isCurrentPasswordIncluded={true}
      />
    </>
  );
}

export default ResetPasswordContainer;
